import { Link } from "react-router-dom";
import { useConsent } from "@/context/ConsentContext";

const COL = "text-[13px] text-[#5A626A] transition-colors duration-300 hover:text-[#1A1A1A]";

export const Footer = () => {
  const { openPreferences } = useConsent();
  return (
    <footer className="mt-32 border-t border-[#E5E0D8]" data-testid="site-footer">
      <div className="container-x grid gap-12 py-20 md:grid-cols-12">
        <div className="md:col-span-6">
          <p className="text-[13px] tracking-[0.42em]">LASZLO ABONYI</p>
          <p className="mt-5 max-w-sm font-display text-2xl font-light leading-snug text-[#3A3733]">
            Paintings of light, architecture and stillness.
          </p>
        </div>
        <div className="flex flex-col gap-3 md:col-span-3">
          <p className="eyebrow mb-2">Collection</p>
          <Link to="/gallery?filter=originals" data-testid="footer-link-originals" className={COL}>Original paintings</Link>
          <Link to="/gallery?filter=canvas" data-testid="footer-link-canvas" className={COL}>Canvas prints</Link>
          <Link to="/gallery?filter=posters" data-testid="footer-link-posters" className={COL}>Fine art posters</Link>
        </div>
        <div className="flex flex-col items-start gap-3 md:col-span-3">
          <p className="eyebrow mb-2">Information</p>
          <Link to="/about" data-testid="footer-link-about" className={COL}>About the artist</Link>
          <Link to="/faq" data-testid="footer-link-faq" className={COL}>FAQ, shipping & returns</Link>
          <button data-testid="footer-cookie-link" onClick={openPreferences} className={COL}>Cookie Preferences</button>
        </div>
      </div>
      <div className="container-x flex flex-col justify-between gap-3 border-t border-[#F0EDE6] py-8 text-[11px] tracking-[0.12em] text-[#8A8780] sm:flex-row">
        <span>© {new Date().getFullYear()} Laszlo Abonyi. All rights reserved.</span>
        <Link to="/admin" data-testid="footer-studio-link" className="transition-colors hover:text-[#1A1A1A]">Studio</Link>
      </div>
    </footer>
  );
};
